<template>
  <v-container v-if="offer" :loading="loading">
    <v-row>
      <v-col>
        <v-btn class="m-0" @click="dialog = true">
          Status ändern
        </v-btn>
      </v-col>
      <statuswahl
        :offer="offer"
        :offerstatus="offerstati"
        :opened="dialog"
        @close="dialog = false"
      />
    </v-row>
    <v-timeline dense clipped>
      <v-slide-x-transition group>
        <template v-for="(status, index) in offer.offer_status">
          <v-timeline-item :key="status.pivot.id" class="mb-4">
            <v-row justify="space-between">
              <v-col cols="7">
                Status
                <v-chip
                  class="white--text ml-0"
                  color="primary"
                  label
                  v-text="status.status_code"
                />
                <span v-text="status.title" />
              </v-col>
              <v-col
                class="text-right"
                cols="5"
                v-text="getDateString(status.pivot.created_at)"
              />
            </v-row>
          </v-timeline-item>

          <v-timeline-item
            v-if="index === 0"
            :key="index"
            color="grey"
            icon-color="grey lighten-2"
            large
          >
            <v-row>
              <v-col>Kommentar hinzufügen:</v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-text-field
                  v-model="commentInput.label"
                  hide-details
                  flat
                  label="Label"
                />
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="commentInput.text"
                  hide-details
                  flat
                  label="Text"
                />
              </v-col>
              <v-col>
                <v-btn class="m-0" depressed @click="comment">
                  Speichern
                </v-btn>
              </v-col>
            </v-row>
          </v-timeline-item>

          <v-timeline-item
            v-for="data in status.pivot.data"
            :key="data.id"
            class="mb-4"
            color="grey"
            icon-color="grey lighten-2"
            small
          >
            <v-row justify="space-between">
              <v-col cols="2">
                <v-chip
                  class="white--text ml-0"
                  color="grey"
                  label
                  v-text="data.key"
                />
              </v-col>
              <v-col>
                <span v-text="data.value" />
              </v-col>
              <v-col
                class="text-right"
                cols="2"
                v-text="getDateString(data.created_at)"
              />
            </v-row>
          </v-timeline-item>
        </template>
      </v-slide-x-transition>
    </v-timeline>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import { formattedDateTimeString } from '@/plugins/formatDate.js'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Angebot',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      offer: {
         type: Object,
         required: true,
      },
      offerData: {
         type: Object,
         required: true,
      },
      overview: {
         type: Object,
         required: true,
      },
      offerstati: {
         type: Array,
         required: true,
      },
   },
   data () {
      return {
         dialog: false,
         loading: true,
         tab: 'main',
         commentInput: {
            label: '',
            text: '',
         },
      }
   },
   methods: {
      async comment () {
         this.$inertia.post(
            `/offer/${this.offer.id}/status/${this.offer.offer_status[0].pivot.id}/comment`,
            this.commentInput,
            {
               preserveState: true,
               onSuccess: (page) => {
                  page.$inertia.reload({ only: ['offerstati'] })
                  console.log('success')
               },
            }
         )
      },
      getDateString (dateVal) {
         return formattedDateTimeString(dateVal)
      },
      downloadStueckliste () {
         this.$inertia.visit()
      },
   },
}
</script>
